import { Pagination, paginationToParams } from '../Pagination';

export interface RefundFilter {
  email?: string;
  pagination: Pagination;
}

export const refundFilterToParams = (refundFilter: RefundFilter) => ({
  email: refundFilter.email || undefined,
  ...paginationToParams(refundFilter.pagination),
});
